import { Pipe, PipeTransform } from '@angular/core';
import {SelectItem} from 'primeng/api';

@Pipe({
  name: 'findSelectedOption',
})
export class FindSelectedOptionPipe implements PipeTransform {
  constructor() {}

  transform(options: SelectItem[], value: string): SelectItem {
    if (!!options && !!value) {
      return options.find(item => item.value === value);
    }
    else return null;
  }
}
